export default __webpack_public_path__ + "static/media/logo-white.313d71a9.svg";